import React from 'react';
import {SimpleGrid} from '@chakra-ui/react';
import MissionCardBD from './MissionCardBD';
import {Mission} from '../mission/MissionService';

interface HistoriqueBDListProps {
    missions: Mission[] | null | undefined;
    onOpenModal: (mission: Mission) => void;
    onDelete: (mission: Mission) => void;
    onEdit: (mission: Mission) => void;
}

export const HistoriqueBDList: React.FC<HistoriqueBDListProps> = ({
                                                                      missions,
                                                                      onOpenModal,
                                                                      onDelete,
                                                                      onEdit,
                                                                  }) => {
    const safeMissions = missions || [];

    return (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
            {safeMissions.map((mission) => (
                <MissionCardBD
                    key={mission.id}
                    mission={mission}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onOpenModal={onOpenModal}
                />
            ))}
        </SimpleGrid>
    );
};